/**
 * Meditation (นั่งสมาธิ): sitting down out of a fight to restore qi and blood faster (and, through
 * systems/cultivation.ts, to build cultivation faster). Moving, guarding, fighting, riding and much
 * else stands the player up again: those rules call `World.stopMeditating`, which comes here.
 */
import { combatBlockText } from '../data/combat';
import type { SystemHost, WorldSystem } from './types';

export const MEDITATION = {
  /** Qi and out-of-combat HP regeneration × this while sitting. */
  regenMult: 3,
} as const;

export class MeditationSystem implements WorldSystem {
  readonly name = 'meditation';

  constructor(private readonly h: SystemHost) {}

  readonly commands = {
    meditate: () => this.toggle(),
  };

  regenMult(): number {
    return this.h.world.player.meditating ? MEDITATION.regenMult : 1;
  }

  /** Sits down (out of a fight, dismounting), or stands up if already sitting. */
  toggle(): void {
    const p = this.h.world.player;
    if (p.meditating) return this.stop();
    if (p.dead) return;
    if (p.combatT > 0) return this.h.notice(combatBlockText(p, 'นั่งสมาธิไม่ได้'));
    this.h.dismount();
    p.meditating = true;
    p.path = null;
    this.h.input.engage = false;
    this.h.emit({ type: 'meditate', on: true });
  }

  /** Stands up, if sitting. */
  stop(): void {
    const p = this.h.world.player;
    if (!p.meditating) return;
    p.meditating = false;
    this.h.emit({ type: 'meditate', on: false });
  }
}
